import { IHeadCell } from 'components/table/EnhancedTableHead';
import { KafkaTopicSampleItem } from 'models/kafkaTopics/dto';

const tableConfig: IHeadCell<KafkaTopicSampleItem>[] = [
	{
		id: 'offset',
		numeric: true,
		label: 'Offset',
		sortable: true,
	},
	{
		id: 'partition',
		numeric: true,
		label: 'Partition',
		sortable: true,
	},
	{
		id: 'message_timestamp',
		numeric: false,
		label: 'Timestamp',
		sortable: true,
	},
	{
		id: 'sensitivity',
		numeric: false,
		label: 'Sensitivity',
		sortable: true,
	},
	{
		id: 'data_types',
		numeric: false,
		label: 'Data types',
		sortable: false,
	},
	{
		id: 'last_checked',
		numeric: false,
		label: 'Last checked',
		sortable: false,
	},
];

export default tableConfig;
